import { useQuery } from '@tanstack/react-query';
import { useCoinMode } from '@ui/hooks/useCoinMode';
import { useLiquidCoinBalance } from '@ui/hooks/useLiquidCoinBalance';
import { useLiquidCoinUsd } from '@ui/hooks/useLiquidCoinUsd';
import { useRouter } from '@ui/overrides/next/router';
import { getQuery } from '@ui/queries/queries';
import { QueryKey } from '@ui/queries/queryKey';
import { useSupplyLcroModalStore } from '@ui/views/UseLcroDirectly/useSupplyLcroModalStore';
import { useEffect } from 'react';

const useUseLcro = () => {
  const globalCoinMode = useCoinMode();
  const openModal = useSupplyLcroModalStore((s) => s.open);
  const { query } = useRouter();
  const { deposit } = query;

  useEffect(() => {
    if (deposit === 'ferro')
      openModal({
        type: 'FERRO',
        coinMode: globalCoinMode,
      });
    else if (deposit === 'vvs')
      openModal({
        type: 'VVS',
        coinMode: globalCoinMode,
      });
    else if (deposit === 'tectonic')
      openModal({
        type: 'TECTONIC',
        coinMode: globalCoinMode,
      });
    else if (deposit === 'vvs_cro')
      openModal({
        type: 'VVS_CRO',
        coinMode: globalCoinMode,
      });
    else if (deposit === 'vvs_tia')
      openModal({
        type: 'VVS_TIA',
        coinMode: globalCoinMode,
      });
  }, [deposit, globalCoinMode, openModal]);

  const { data: liquidBalance, isLoading: liquidBalanceLoading } =
    useLiquidCoinBalance();

  const { data: liquidBalanceUsd, isLoading: liquidBalanceUsdLoading } =
    useLiquidCoinUsd({ amount: liquidBalance });

  const ferroApyQuery = getQuery(QueryKey.FERRO_APY)(globalCoinMode);
  const { data: ferroApy, isLoading: ferroApyLoading } = useQuery(
    ferroApyQuery.queryKey,
    ferroApyQuery.queryFn,
  );

  return {
    liquidBalanceUsd,
    liquidBalance,
    liquidBalanceUsdLoading,
    liquidBalanceLoading,
    ferroApy,
    ferroApyLoading,
  };
};

export default useUseLcro;
